import React from 'react';
import loadable from '@loadable/component';
import { clearResults } from 'store/search/searchActions';

export const AsyncMapSearchLayout = loadable(() => import(/* webpackPrefetch: true */ './MapSearchLayout'));

const MapSearch = (props) => {
  return <AsyncMapSearchLayout {...props} />;
};

MapSearch.onExitPage = ({ store }) => {
  store.dispatch(clearResults());
};

export default MapSearch;
